module.exports = __webpack_public_path__ + "img/telegram.b771cc4.svg?v=1764823240413";